import React from 'react';
import './styles.css';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import banner from './ERP/banner.png';

export default function FichaTecnicaERP(props){


    return(<>
    <div className='contenedorGeneralFichaTecnicaERP'>
        <div className='contenedorFichaTecnicaERP'>
            <div className='contenedorImagenesFichaTecnicaERP'>
                <Carousel autoPlay infiniteLoop  showArrows={false} showStatus={false} showThumbs={false} dynamicHeight={true} stopOnHover={false} interval={5000}>
                <div className='contenedorImagenCarouselCFDI'><img src={banner}/>
                {/* <div className='textoOverCFDI'><h1>Gestiona, Organiza y Revisa</h1>
                <h2>cada uno de tus proyectos</h2></div> */}
                </div>
                </Carousel>
            </div>
            <div className='contenedorTextoBotonCFDI'>
                <div className='contenedorTextoFichaTecnicaERP'>
                    <p>
                    T&T ERP es un Sistema Integral que facilita la operación del negocio.
                       <br/>
                       Proporciona información de calidad que ayuda a tomar decisiones oportunas y relevantes. Su diseño está pensado en tener al máximo una reducción de tiempo en la ejecución de cada uno de los procesos, evitando duplicidad de información, captura excesiva de datos y además permite producir los resultados para cubrir las necesidades requeridas por la empresa.
                        
                    </p>
                </div>
                <div>
                <a href={'https://procesos.tytsoftwaredemexico.com/aXR6bWlu/descargas/fichaTecnicaERP.pdf'} target='_blank'>
                    <button type="button" className='botonFichaTecnicaERP'>
                        Ver ficha técnica
                    </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
    </>)
}